import keyMirror from '../../utils/keyMirror.js';

export const sharePlatformNames = keyMirror('FACEBOOK', 'TWITTER', 'TUMBLR');
